import {HistoryStorageWithMaterial, MaterialType} from '@domain/material-storage'
import {Moment} from 'moment-timezone'

export enum StockReachState {
  Future = 'future',
  Date = 'date'
}

export type StockReachValue =
  | {type: StockReachState.Date; date: Moment}
  | {type: StockReachState.Future; date: Moment}

export interface MaterialInfo {
  materialId: string
  materialType: MaterialType
  capacity: number
  level: number
  reachDate: StockReachValue | undefined // undefined is not loaded yet, null is reach unknown
  storages: HistoryStorageWithMaterial[]
}

export enum ReachVariant {
  ok = 'ok',
  info = 'info',
  warning = 'warning',
  other = 'other'
}
